import { get } from 'lodash';

const root = (state) =>
  get(state, 'ManageIngredientState.removeReplaceIngredient');

export const getFetchRecipesLoading = (state) =>
  get(root(state), 'fetchRecipesLoading');
export const getRemoveIngredientLoading = (state) =>
  get(root(state), 'removeIngredientLoading');
export const getReplaceIngredientLoading = (state) =>
  get(root(state), 'replaceIngredientLoading');
export const getRecipes = (state) => get(root(state), 'recipes');
export const getFetchRecipesError = (state) =>
  get(root(state), 'fetchRecipesError');
export const getRemoveIngredientError = (state) =>
  get(root(state), 'removeIngredientError');
export const getReplaceIngredientError = (state) =>
  get(root(state), 'replaceIngredientError');
export const getIsSubmitSuccess = (state) =>
  get(root(state), 'isSubmitSuccess');



// WEBPACK FOOTER //
// ./src/pages/manageingredient/state/removereplaceingredient/selectors.js